import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var answerSummary = props.answerSummary;
  var questions = answerSummary.questions;
  var questionKeys = Object.keys(questions);
  var exampleAnswers = questions[questionKeys[0]].answers;
  var answerKeys = Object.keys(exampleAnswers).sort();
  var tableHalfWidth = answerKeys.length <= 3;
  return {
    tableWrapper: {
      display: 'flex',
      flexBasis: '100%',
      flexDirection: 'column',
      paddingBottom: componentTheme.tableBottomPadding
    },
    iconWrapper: {
      display: 'flex',
      height: '100%',
      minHeight: '47px',
      width: '46px',
      justifyContent: 'center',
      alignItems: 'center'
    },
    iconCorrect: {
      backgroundColor: componentTheme.colorGreen,
      svg: {
        fill: 'white'
      }
    },
    correctAnswerRow: {
      borderColor: componentTheme.colorGreen,
      borderStyle: 'solid',
      '> span > span:nth-of-type(2)': {
        minWidth: '46px',
        padding: '12px 12px 12px 12px'
      },
      borderWidth: '2px 2px 2px 2px',
      borderRadius: '4px 4px 4px 4px'
    },
    tableContainer: _objectSpread({
      'table tbody tr th': {
        fontWeight: '400'
      }
    }, tableHalfWidth && {
      width: 'calc(25% + 350px)',
      maxWidth: '100%'
    })
  };
};
export default generateStyle;